import React from "react";
import Modal from "react-bootstrap/Modal";
import Avatar from "../../../../../assets/images/avatarr.png";
import Phone from "../../../../../assets/images/phone.png";
import { toast } from "react-toastify";

const SecondEvacuationCodeModal = ({
  showEvacuation2,
  handleCloseEvacuation2,
  modalInfo,
  handleShowAuthenticate,
  evacNylon,
  evacPet,
  evacGroups,
  setEvacGroup,
  setEvacNylon,
  setEvacPet,
  setEvacCode,
}) => {
  const byProduct =
    Array.isArray(modalInfo?.evacuation_groups) && modalInfo.evacuation_groups.length
      ? modalInfo.evacuation_groups
      : null;

  // What the factory has weighed in so far, whichever shape the request used.
  const factoryTotal = byProduct
    ? byProduct.reduce((sum, g) => {
        const n = parseFloat(evacGroups?.[g.label]);
        return sum + (isNaN(n) ? 0 : n);
      }, 0)
    : (parseFloat(evacPet) || 0) + (parseFloat(evacNylon) || 0);

  const centerTotal = Number(modalInfo?.total_requested_kg) || 0;

  return (
    <div>
      <Modal
        show={showEvacuation2}
        onHide={() => {
          handleCloseEvacuation2();
          setEvacNylon(null);
          setEvacPet(null);
          setEvacCode(null);
          window.location.reload();
        }}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <div class="modal-header">
          <h5 class="modal-title">Enter Weight</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              handleCloseEvacuation2();
              setEvacNylon(null);
              setEvacPet(null);
              window.location.reload();
            }}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <Modal.Body>
          <div className="mx-2">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex mt-4">
                <div style={{ width: "35px" }}>
                  <img src={Avatar} alt="avatar" style={{ width: "100%" }} />
                </div>
                <div>
                  <p
                    className="mb-0 ml-2"
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "#000",
                    }}
                  >
                    {modalInfo?.center?.name}
                  </p>
                  <p
                    className="mb-0 ml-2"
                    style={{ fontSize: "14px", color: "#898989" }}
                  >
                    {modalInfo?.center?.address}
                  </p>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center">
              <div style={{ width: "60%" }}>
                {/* The center raised this request per product, so it is
                    weighed in per product: a single PET figure cannot say how
                    much of it was Clear & Light blue and how much Mix Color,
                    and the difference is recorded per product. Requests raised
                    the old way still get the two coarse fields below. */}
                {Array.isArray(modalInfo?.evacuation_groups) &&
                modalInfo.evacuation_groups.length ? (
                  modalInfo.evacuation_groups.map((group) => (
                    <div className="mb-3 mt-3" key={group.label}>
                      <label className="mb-1 form-label">
                        {group.name || group.label} (kg)
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-lg inputStyle"
                        placeholder={`Enter ${group.name || group.label} kg`}
                        value={evacGroups?.[group.label] ?? ""}
                        onChange={(e) =>
                          setEvacGroup(
                            group.label,
                            e.target.value.replace(/[^0-9.]/g, "")
                          )
                        }
                      />
                      <small style={{ color: "#898989" }}>
                        {`Center declared ${Number(group.requested_kg) || 0}kg`}
                      </small>
                    </div>
                  ))
                ) : (
                  <>
                {modalInfo?.pet_plastic_kg >= 0 && (
                  <div className="mb-3 mt-4">
                    <label className="mb-1 form-label">PET Plastics (kg)</label>
                    <input
                      type="text"
                      className="form-control form-control-lg inputStyle"
                      placeholder="Enter PET Plastic kg"
                      value={evacPet}
                      onChange={(e) =>
                        setEvacPet(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                    <small style={{ color: "#898989" }}>
                      {`Center declared ${Number(modalInfo?.pet_plastic_kg) || 0}kg`}
                    </small>
                  </div>
                )}

                {modalInfo?.nylon_kg >= 0 && (
                  <div className="mb-3 mt-3">
                    <label className="mb-1 form-label">Nylon (kg)</label>
                    <input
                      type="text"
                      className="form-control form-control-lg inputStyle"
                      placeholder="Enter Nylon kg"
                      value={evacNylon}
                      onChange={(e) =>
                        setEvacNylon(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                    <small style={{ color: "#898989" }}>
                      {`Center declared ${Number(modalInfo?.nylon_kg) || 0}kg`}
                    </small>
                  </div>
                )}
                  </>
                )}
              </div>
              <div>
                <div className="mt-4">
                  <p
                    className="mb-0 mr-2"
                    style={{
                      fontSize: "13px",
                      color: "#000000",
                      fontWeight: "600",
                    }}
                  >
                    3rd Party Driver Details
                  </p>
                </div>
                <div className="d-flex align-items-center mt-2">
                  <img src={Avatar} alt="avatar" />
                  <p
                    className="mb-0 ml-2"
                    style={{ fontSize: "14px", color: "#000" }}
                  >
                    {modalInfo?.driver_name}
                  </p>
                </div>
                <div className="d-flex align-items-center mt-4">
                  <img src={Phone} alt="phone" />
                  <p
                    className="mb-0 ml-2"
                    style={{ fontSize: "14px", color: "#898989" }}
                  >
                    {modalInfo?.driver_phone}
                  </p>
                </div>
                <div className="mt-4">
                  <p
                    className="mb-0 mr-2"
                    style={{ fontSize: "13px", color: "#000" }}
                  >
                    Vehicle No:
                  </p>
                  <p
                    className="mb-0 mr-2"
                    style={{
                      fontSize: "13px",
                      color: "#000000",
                      fontWeight: "400",
                    }}
                  >
                    {modalInfo?.vehicle_plate_no}
                  </p>
                </div>
              </div>
            </div>
            <div>
              <p
                className="mb-0 mr-2"
                style={{
                  fontSize: "13px",
                  color: "#000000",
                  fontWeight: "600",
                }}
              >
                {`Factory Total Weight: ${factoryTotal.toFixed(2)}kg`}
              </p>
              {/* What the center declared, in the products it declared. This
                  used to print the pet_plastic/nylon roll-up regardless, so a
                  truck of Clear & Light blue PET read as "PET Plastics" and a
                  truck of CAN or Aluminum read as 0kg of both. */}
              <div className="mt-4">
                <div className="d-flex align-items-center items-center flex-wrap">
                  {byProduct ? (
                    byProduct.map((group) => (
                      <div className="text-center mr-5" key={group.label}>
                        <p
                          className="mb-0 mr-2"
                          style={{ fontSize: "13px", color: "#000000" }}
                        >
                          {`${group.name || group.label} ~ Center`}
                        </p>
                        <p
                          className="ml-0 mb-0"
                          style={{
                            fontSize: "14px",
                            color: "#404040",
                            fontWeight: "400",
                          }}
                        >
                          {`${Number(group.requested_kg) || 0}kg`}
                        </p>
                      </div>
                    ))
                  ) : (
                    <>
                  <div className="text-center">
                    <p
                      className="mb-0 mr-2"
                      style={{ fontSize: "13px", color: "#000000" }}
                    >
                      PET Plastics ~ Center
                    </p>
                    <p
                      className="ml-0 mb-0"
                      style={{
                        fontSize: "14px",
                        color: "#404040",
                        fontWeight: "400",
                      }}
                    >
                      {`${modalInfo?.pet_plastic_kg}kg`}
                    </p>
                  </div>

                  <div className="text-center ml-5">
                    <p
                      className="mb-0 mr-2"
                      style={{ fontSize: "13px", color: "#000000" }}
                    >
                      Nylon ~ Center
                    </p>
                    <p
                      className="ml-0 mb-0"
                      style={{
                        fontSize: "14px",
                        color: "#404040",
                        fontWeight: "400",
                      }}
                    >
                      {`${modalInfo?.nylon_kg}kg`}
                    </p>
                  </div>
                    </>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <p
                  className="mb-0 mr-2 mt-4"
                  style={{
                    fontSize: "13px",
                    color: "#000000",
                    fontWeight: "600",
                  }}
                >
                  {`Center Total Weight: ${modalInfo?.total_requested_kg}kg`}
                </p>
                <p
                  className="mb-0 mr-2 mt-4"
                  style={{
                    fontSize: "13px",
                    color: "#000000",
                    fontWeight: "600",
                  }}
                >
                  {`Weight Difference: ${(centerTotal - factoryTotal).toFixed(2)}kg`}
                </p>
              </div>
            </div>

            <div style={{ width: "50%" }}>
              <div className="mt-4 mb-5 ">
                <button
                  type="button"
                  className="btn loginBtn btn-sm btn-block w-75"
                  onClick={() => {
                    if (byProduct) {
                      const missing = byProduct.find((g) => {
                        const n = parseFloat(evacGroups?.[g.label]);
                        return isNaN(n) || n <= 0;
                      });

                      if (missing) {
                        toast.error(
                          `Please enter a valid weight for ${missing.name || missing.label}`
                        );
                        return;
                      }
                    } else {
                    const centerNylon = Number(modalInfo?.nylon_kg) || 0;
                    const centerPet = Number(modalInfo?.pet_plastic_kg) || 0;
                    const enteredNylon = Number(evacNylon);
                    const enteredPet = Number(evacPet);

                    if (centerNylon > 0 && !evacNylon) {
                      toast.error("Please enter the weights for Nylon");
                      return;
                    }
                    if (centerPet > 0 && !evacPet) {
                      toast.error("Please enter the weights for PET Plastic");
                      return;
                    }
                    if (evacNylon && (Number.isNaN(enteredNylon) || enteredNylon <= 0)) {
                      toast.error("Please enter a valid weight for Nylon");
                      return;
                    }
                    if (evacPet && (Number.isNaN(enteredPet) || enteredPet <= 0)) {
                      toast.error("Please enter a valid weight for PET Plastic");
                      return;
                    }
                    }

                    handleCloseEvacuation2();
                    handleShowAuthenticate();
                  }}
                >
                  Complete Evacuation
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SecondEvacuationCodeModal;

// 256223
